fragment DocumentSender on Document {
  id
  senderMetadata {
    name
    email
    phone
  }
}
